import React from "react";
import classNames from "classnames";
import styles from "./Tag.module.scss"

/**
 *
 * @param color - oneOf: chart-1, chart-9, disabled
 */
const Tag = ({children, className, style, color = "chart-1"}) => {
    return <div className={classNames(styles['base'], styles[color], className)} style={style}>
        {children}
    </div>
}

export default Tag;
